import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnsupportedBrowserComponent } from './unsupported-browser/unsupported-browser.component';
import { SharedModule } from '../../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { FilterComponent } from './filter/filter.component';
import { PagingComponent } from './paging/paging.component';
import { MyNavigationComponent } from './my-navigation/my-navigation.component';
import { MyMembershipStatusNavigationComponent } from './my-membership-status-navigation/my-membership-status-navigation.component';
import { SelectProductComponent } from './select-product/select-product.component';
import { ProductSingleComponent } from './product/product-single.component';
import { OrderNavigationComponent } from './order-navigation/order-navigation.component';
import { ProductSingleRenewComponent } from './product-single-renew/product-single-renew.component';
import { ProductReviewsComponent } from './product-reviews/product-reviews.component';
import { NgxStarsModule } from 'ngx-stars';
import { SelectBulkProductComponent } from './select-bulk-product/select-bulk-product.component';
// import { ReadMoreModule } from 'ng-readmore';
// import { LightboxModule } from 'ngx-lightbox';
// import { GalleryModule } from '@ngx-gallery/core';
// import { GallerizeModule } from '@ngx-gallery/gallerize';

const COMPONENTS = [
  FilterComponent,
  PagingComponent,
  MyNavigationComponent,
  MyMembershipStatusNavigationComponent,
  ProductSingleComponent,
  ProductSingleRenewComponent,
  UnsupportedBrowserComponent,
  SelectProductComponent,
  OrderNavigationComponent,
  ProductReviewsComponent,
  SelectBulkProductComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    RouterModule,
    CommonModule,
    NgxStarsModule,
    // ReadMoreModule,
    // LightboxModule,
    // GalleryModule,
    // GallerizeModule,
    SharedModule.forRoot(),
  ],
  exports: [...COMPONENTS],
})
export class ComponentModule {}
